import { ReactNode } from 'react';

import { Heading24, TextCenter } from 'approot/shared/styles/typography.style';
import { AccessibleHeading24 } from 'approot/shared/ally/accessible-heading';
import { LayoutNarrowCenteredContentStyled } from './layout.styles';

type Props = {
  headingText?: string;
  headingElement?: ReactNode;
  image?: ReactNode;
  children: ReactNode;
  useAccessibleHeading?: boolean;
};

const LayoutCenteredMessage = ({
  image,
  headingText,
  headingElement,
  children,
  useAccessibleHeading = true,
}: Props) => {
  return (
    <LayoutNarrowCenteredContentStyled>
      <TextCenter>
        {image}
        {useAccessibleHeading && headingText ? (
          <AccessibleHeading24
            marginTop={16}
            marginBottom={8}
            fontWeight="medium"
          >
            {headingText}
          </AccessibleHeading24>
        ) : (
          headingText && (
            <Heading24 marginTop={16} marginBottom={8}>
              {headingText}
            </Heading24>
          )
        )}
        {headingElement}
        {children}
      </TextCenter>
    </LayoutNarrowCenteredContentStyled>
  );
};

export default LayoutCenteredMessage;
